<template>
    <div>
        <b-row>
            <b-col>
                <b-form-radio
                    :value="0"
                    v-model="dateRangeOptions.dateOption"
                    @change="eventSetDates(0)"
                >
                    Today
                </b-form-radio>
            </b-col>
        </b-row>
        <b-row class="pt-1">
            <b-col>
                <b-form-radio
                    :value="1"
                    v-model="dateRangeOptions.dateOption"
                    @change="eventSetDates(1)"
                >
                    Yesterday
                </b-form-radio>
            </b-col>
        </b-row>
        <b-row class="pt-1">
            <b-col>
                <b-form-radio
                    :value="2"
                    v-model="dateRangeOptions.dateOption"
                    @change="eventSetDates(2)"
                >
                    Custom
                </b-form-radio>
            </b-col>
        </b-row>
        <b-row class="pt-2">
            <b-col>
                <p-datepicker
                    label="Start Date"
                    vid="startDate"
                    v-model="dateRangeOptions.startDate"
                    :disabled="disabled"
                    rules="required"
                />
            </b-col>
            <b-col>
                <p-datepicker
                    label="End Date"
                    vid="endDate"
                    v-model="dateRangeOptions.endDate"
                    rules="required|dateGreaterOrEqual:@startDate"
                    :disabled="disabled"
                    is-end-date
                />
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    name: 'p-date-range-widget',
    components: {},
    props: {
        dateRangeOptions: {
            dateOption: 0,
            startDate: null,
            endDate: null,
        }
    },
    computed: {
        // Derived rather than stored so the date pickers also unlock when dateOption is
        // set programmatically (e.g. restoring a saved report template), not just by radio click.
        disabled() {
            return this.dateRangeOptions.dateOption != 2;
        }
    },
    methods: {
        async loadData() {
            let today = this.getToday();

            this.dateRangeOptions.endDate = today;
            this.dateRangeOptions.startDate = today;
            this.dateRangeOptions.dateOption = 0;
        },
        getToday(){
            let today = new Date();
            return today;
        },
        getYesterday(){
            let yesterday = (d => new Date(d.setDate(d.getDate() - 1)))(
                new Date()
            );

            return yesterday;
        },
        eventSetDates(value) {
            // Custom keeps whatever dates are already showing; the pickers just become editable.
            if (value == 2) {
                return;
            }

            let date = value == 1 ? this.getYesterday() : this.getToday();

            this.dateRangeOptions.startDate = date;
            this.dateRangeOptions.endDate = date;
        }
    },
    created: async function() {
        await this.loadData();
    },
    mounted: async function() {
        await this.loadData();
    },
};
</script>
